const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    if (!s || s.length == 0) return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export default capitalize;